// Jun 2026 · "Recently viewed" glossary terms — tiny localStorage ring
// buffer shared by the Glossary page, the in-app term popovers, and the
// global quick search. Most recent first, capped at 5, de-duped.
const KEY = "tlb_glossary_recent_v1";
const MAX_RECENT = 5;

export function recordGlossaryView(term) {
  if (!term) return;
  try {
    const list = JSON.parse(window.localStorage.getItem(KEY) || "[]")
      .filter((t) => t !== term);
    list.unshift(term);
    window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_RECENT)));
  } catch {
    // Private mode / storage full — recents are a nicety, never a blocker.
  }
}

export function getRecentGlossaryTerms() {
  try {
    return JSON.parse(window.localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}
